import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrowserStorageService } from './browser.storage.service';
import { log } from 'console';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private platformId = inject<Object>(PLATFORM_ID);

    readonly #browserStorageService = inject(BrowserStorageService);

    private language: string;

    constructor() {
        if (isPlatformBrowser(this.platformId)) {
            this.language =
                JSON.parse(this.#browserStorageService.getItem('language'))
                    ?.code;

        } else {
            this.language = 'vi';
        }
    }

    getLanguage(): string {
        return this.language;
    }

    //   setLanguage(lang: string): void {
    //     this.language = lang;
    //     if (isPlatformBrowser(this.platformId)) {
    //       sessionStorage.setItem('setLanguage', lang);
    //     }
    //   }
}
